<template>
    <div style="height: 100%">
        <vs-chip v-if="params.data.project_id > 0" class="mr-3" style="height: 60%; top:20%" color="primary">P</vs-chip>{{params.value}}
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
        methods:{
        }
    });

</script>
